// eslint-disable-next-line import/prefer-default-export
export const sideLabelWidth = "288px";
